'use client';

import { createContext, type ReactNode, useCallback, useContext, useMemo, useState } from 'react';

interface Toast {
  id: number;
  text: string;
  error?: boolean;
}

const Ctx = createContext<(text: string, opts?: { error?: boolean }) => void>(() => {});

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<Toast[]>([]);
  const push = useCallback((text: string, opts?: { error?: boolean }) => {
    const id = Date.now() + Math.random();
    setItems((x) => [...x.slice(-3), { id, text, error: opts?.error }]);
    setTimeout(() => setItems((x) => x.filter((t) => t.id !== id)), opts?.error ? 7000 : 3500);
  }, []);
  const value = useMemo(() => push, [push]);
  return (
    <Ctx.Provider value={value}>
      {children}
      <div className="rk-toasts" aria-live="polite">
        {items.map((t) => (
          <div key={t.id} className={t.error ? 'rk-toast rk-toast--error' : 'rk-toast'} role={t.error ? 'alert' : 'status'}>
            {t.text}
          </div>
        ))}
      </div>
    </Ctx.Provider>
  );
}

/** toast('Сохранено') или toast('Ошибка', { error: true }) */
export function useToast() {
  return useContext(Ctx);
}
